import React from 'react';
import { colors } from '../../styles/styles';

/**
 * Reusable plus (+) icon component
 */
const PlusIcon = ({ 
  width = 24, 
  height = 24, 
  color = colors.textSecondary, 
  style = {},
  strokeLinecap = "round",
  strokeLinejoin = "round",
  strokeWidth = 2
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path 
        d="M12 5V19M5 12H19" 
        stroke={color} 
        strokeWidth={strokeWidth} 
        strokeLinecap={strokeLinecap} 
        strokeLinejoin={strokeLinejoin}
      />
    </svg>
  );
};

export default PlusIcon; 